/** Assistant behavior is opt-in and remembered in this browser. */
import { Atom } from './atom.ts';

const AUTO_PLOT_KEY = 'neptune_assistant_auto_plot_v1';

function readAutoPlot(): boolean {
  try {
    return localStorage.getItem(AUTO_PLOT_KEY) === '1';
  } catch {
    return false;
  }
}

export const assistantAutoPlot = new Atom<boolean>(readAutoPlot());

export function setAssistantAutoPlot(on: boolean): void {
  assistantAutoPlot.set(on);
  try {
    localStorage.setItem(AUTO_PLOT_KEY, on ? '1' : '0');
  } catch {
    // The choice still applies for this session if storage is unavailable.
  }
}

const CHIEF_ENGINEER_KEY = 'neptune_assistant_chief_engineer_v1';

function readChiefEngineer(): boolean {
  try {
    return localStorage.getItem(CHIEF_ENGINEER_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Chief Engineer mode: the assistant with its scope and style rules relaxed.
 * Root only - the switch is shown only to root and the server refuses it for
 * anyone else, so what this browser remembers is a preference, not a grant.
 */
export const assistantChiefEngineer = new Atom<boolean>(readChiefEngineer());

export function setAssistantChiefEngineer(on: boolean): void {
  assistantChiefEngineer.set(on);
  try {
    localStorage.setItem(CHIEF_ENGINEER_KEY, on ? '1' : '0');
  } catch {
    // The choice still applies for this session if storage is unavailable.
  }
}
